import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
const packageIncludes = ['Volume 1 — Wrestling Foundations & Movement System', 'Volume 2 — Takedowns, Entries & Neutral Wrestling', 'Volume 3 — Top Control, Breakdowns & Turning System', 'Volume 4 — Escapes, Reversals & Bottom Wrestling System', 'Volume 5 — Chain Wrestling, Situational Drills & Match Intelligence', 'Volume 6 — Competition Development & Complete Practice System', '150 Ready-to-Coach Wrestling Sessions', 'Bonus 1 — 200 Wrestling Drills & Training Games', 'Bonus 2 — Opponent Scouting & Match Analysis Playbook', 'Bonus 3 — Tournament Day Coach Toolkit', 'Bonus 4 — 52-Week Wrestling Training Planner', 'Bonus 5 — 100 Warm-Ups, Movement Games & Finishers', 'Beginner-to-Advanced Adaptations', 'Progression Maps, Decision Trees & Coaching Cues', 'Match Scenarios & Competition Preparation Tools', 'Athlete Development Tools', 'Instant Digital Access', '7-Day Money-Back Guarantee'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white relative" data-id="element-206" data-mp="1cqbx5rl91wif">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-207" data-mp="1coilfxvs4m3k">
        <div className="text-center mb-10" data-id="element-208" data-mp="17t3apet2j6bd">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-navy" data-id="element-209" data-mp="25fitql158c11">
            Your Complete <span className="text-gold-solid" data-id="element-210" data-mp="20gfzlvmpbq7u">6-Volume</span> Offer Today
          </h2>
          <p className="text-azure-dark text-sm md:text-base" data-id="element-211" data-mp="20ed2krn4swtm">
            The complete coaching system — ready for tomorrow&apos;s practice.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-navy rounded-3xl p-1 relative shadow-[0_16px_40px_rgba(15,42,82,0.18)]" data-id="element-212" data-mp="1rezqrsbjbw5q">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-navy-dark font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-213" data-mp="hijbl7qkp0w0">
            <Sparkles size={14} data-id="element-214" data-mp="7ly6ynigtrsp" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-215" data-mp="ch3s3k41n2fq">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-3" data-id="element-216" data-mp="3uvmtm0lkieh9">
              Wrestling Coach Ready
            </h3>
            <p className="text-base text-slate mb-6" data-id="element-217" data-mp="3k38dqrx5sim">
              The Complete Professional Wrestling Coaching System —{' '}
              <span className="text-gold-solid font-bold" data-id="element-218" data-mp="3pxbjdord21yi">150</span> ready-to-coach sessions +{' '}
              <span className="text-gold-solid font-bold" data-id="element-219" data-mp="3by236p35n7uj">6</span> complete volumes +{' '}
              <span className="text-gold-solid font-bold" data-id="element-220" data-mp="3fzdvx3hbs96y">5</span> bonus guides.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-mist border border-mist-dark rounded-xl p-4" data-id="element-221" data-mp="3g185xmr26gw9">
              {packageIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-navy" data-id="element-222" data-mp="2sdl374u7008c">
                  <Check size={16} className="text-success shrink-0 mt-0.5" data-id="element-223" data-mp="36cks8dlmah51" />
                  <span data-id="element-224" data-mp="31cf6fe213ouv">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-225" data-mp="3g9fnmnmlg1f3">
              <span className="text-lg text-alert line-through block mb-1" data-id="element-226" data-mp="3g8o1e3evzg1h">$137.00</span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-227" data-mp="3b9t8g8n7gb3n">
                <span className="text-2xl md:text-3xl text-navy" data-id="element-228" data-mp="3p2snyamzm5b7">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold-dark" data-id="element-229" data-mp="3l0nxtlvqzqtb">$27.00</span>
              </div>
              <p className="text-sm text-slate mt-3" data-id="element-230" data-mp="2ut2l5uye9a0">
                Pay once. Use it again and again. Instant digital access. No shipping. No
                waiting.
              </p>
            </div>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-231" data-mp="hym5ol37uzgx">
              🟡 GET WRESTLING COACH READY NOW
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate mb-4" data-id="element-232" data-mp="qr64pmnf762a">
              <span className="flex items-center gap-1.5" data-id="element-233" data-mp="vrlj8hjfujlu">
                <Lock size={12} className="text-azure" data-id="element-234" data-mp="3v5nwrzam62cq" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-235" data-mp="301winnmunf3">
                <Zap size={12} className="text-azure" data-id="element-236" data-mp="32mxlag3wzbs" /> Instant Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-237" data-mp="81zihpnf3wbq">
                <Shield size={12} className="text-azure" data-id="element-238" data-mp="d016mozpalu2" /> 7-Day Guarantee
              </span>
            </div>
            <div className="bg-mist border border-mist-dark rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-239" data-mp="1jejw758cn9f0">
              <Globe className="text-azure shrink-0 mt-0.5" size={14} data-id="element-240" data-mp="1ofzif0m9jlyz" />
              <p className="text-[11px] text-slate leading-snug" data-id="element-241" data-mp="38vnwr1c95am5">
                Pay in your local currency. The amount adjusts automatically based on your
                country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}